// @ts-nocheck
import React from 'react';
import KwPanel from '../../../common/KwPanel';
import FormInput from '../../../common/FormInput';
import FormToggleBool from '../../../common/FormToggleBool';
import { useTranslation } from 'react-i18next';

export interface CloneWorkflowFormProps {
  errors?: Record<string, unknown>;
  register: (name: string, options?: unknown) => unknown;
  control?: unknown;
}

const CloneWorkflowForm = ({ register, errors, control }: CloneWorkflowFormProps) => {
  const { t } = useTranslation();
  return (
    <KwPanel className="mb-4">
      <FormInput
        register={register}
        required={true}
        error={errors?.name}
        errorMessage={t('Name is required')}
        name="name"
        label={t('Name')}
        placeholder={t('Name of the workflow')}
        autoFocus={true}
      />
      <FormToggleBool
        control={control}
        name="withRestrictions"
        label={t('Clone restrictions?')}
        defaultValue={false}
      />
    </KwPanel>
  );
};

export default CloneWorkflowForm;
